document.addEventListener('DOMContentLoaded', function() {
    const popupOverlay = document.createElement('div');
    popupOverlay.className = 'video-popup-overlay';
    popupOverlay.innerHTML = `
        <div class="video-popup-container">
            <button class="video-popup-close">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18" stroke="white" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </button>
            <button class="video-popup-nav video-popup-prev">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
                </svg>
            </button>
            <div class="video-popup-content">
                <video controls>
                    <source src="" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>
            <button class="video-popup-nav video-popup-next">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L15 12L9 6" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
                </svg>
            </button>
        </div>
    `;
    document.body.appendChild(popupOverlay);

    const videoPopup = {
        overlay: popupOverlay,
        container: popupOverlay.querySelector('.video-popup-container'),
        video: popupOverlay.querySelector('video'),
        closeBtn: popupOverlay.querySelector('.video-popup-close'),
        prevBtn: popupOverlay.querySelector('.video-popup-prev'),
        nextBtn: popupOverlay.querySelector('.video-popup-next'),
        videos: [],
        currentIndex: 0,

        init(videoUrls) {
            this.videos = videoUrls;
            this.prevBtn.addEventListener('click', () => this.navigate('prev'));
            this.nextBtn.addEventListener('click', () => this.navigate('next'));
            this.updateNavigationVisibility();
        },

        navigate(direction) {
            if (this.videos.length <= 1) return;
            
            const videoContent = this.container.querySelector('.video-popup-content');
            videoContent.classList.add('transitioning');
            
            // Store current video time to maintain position
            const currentTime = this.video.currentTime;
            
            // Calculate new index
            if (direction === 'next') {
                this.currentIndex = (this.currentIndex + 1) % this.videos.length;
            } else {
                this.currentIndex = (this.currentIndex - 1 + this.videos.length) % this.videos.length;
            }
            
            // Wait for fade out
            setTimeout(() => {
                this.video.pause();
                const nextVideoUrl = this.videos[this.currentIndex];
                this.video.src = nextVideoUrl;
                
                // Handle video load and play
                this.video.addEventListener('loadeddata', () => {
                    // Remove transition class to fade in
                    videoContent.classList.remove('transitioning');
                    // Try to maintain similar position in new video
                    if (this.video.duration > currentTime) {
                        this.video.currentTime = currentTime;
                    }
                    this.video.play();
                }, { once: true });
            }, 300); // Match this with CSS transition duration
        },

        updateNavigationVisibility() {
            const showNav = this.videos.length > 1;
            this.prevBtn.style.display = showNav ? 'flex' : 'none';
            this.nextBtn.style.display = showNav ? 'flex' : 'none';
        },
        
        open(videoUrl, index) {
            this.currentIndex = index;
            const videoContent = this.container.querySelector('.video-popup-content');
            videoContent.classList.add('transitioning');
            
            this.video.src = videoUrl;
            this.overlay.classList.add('active');
            document.body.style.overflow = 'hidden';
            this.updateNavigationVisibility();
            
            // Handle initial video load
            this.video.addEventListener('loadeddata', () => {
                videoContent.classList.remove('transitioning');
                this.video.play();
            }, { once: true });
        },
        
        close() {
            this.video.pause();
            this.video.src = '';
            this.overlay.classList.remove('active');
            document.body.style.overflow = '';
        }
    };

    // Close popup handlers
    videoPopup.closeBtn.addEventListener('click', () => {
        videoPopup.close();
    });

    videoPopup.overlay.addEventListener('click', (e) => {
        if (e.target === videoPopup.overlay) {
            videoPopup.close();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (!videoPopup.overlay.classList.contains('active')) return;
        
        if (e.key === 'Escape') {
            videoPopup.close();
        } else if (e.key === 'ArrowLeft') {
            videoPopup.navigate('prev');
        } else if (e.key === 'ArrowRight') {
            videoPopup.navigate('next');
        }
    });

    // Initialize Flickity slider
    const sliderElement = document.querySelector('.video-slider-flick-main'); 
    if (sliderElement) {
      
        const flkty = new Flickity(sliderElement, {
            autoPlay: 8000,
            prevNextButtons: true,
            pageDots: true,
            resize: true,
            contain: true,
            watchCSS: false,
            cellAlign: 'center',
            on: {
                ready: function() {
                    const navigationWrapper = document.querySelector('.slider-navigation-wrapper');
                    const pageDotsElement = sliderElement.querySelector('.flickity-page-dots');
                    const prevButton = sliderElement.querySelector('.flickity-prev-next-button.previous');
                    const nextButton = sliderElement.querySelector('.flickity-prev-next-button.next');
                    
                    if (navigationWrapper && pageDotsElement && prevButton && nextButton) {
                        navigationWrapper.appendChild(prevButton);
                        navigationWrapper.appendChild(pageDotsElement);
                        navigationWrapper.appendChild(nextButton);
                        void navigationWrapper.offsetWidth;
                    }
                }
            }
        });

        window.addEventListener('resize', () => {
            flkty.resize();
        });

        // Initialize video popup with all video URLs
        const videoLinks = document.querySelectorAll('.video-sli-single a');
        const videoUrls = Array.from(videoLinks).map(link => link.getAttribute('href'));
        videoPopup.init(videoUrls);

        // Add click handlers for video links
        videoLinks.forEach((link, index) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const videoUrl = link.getAttribute('href');
                videoPopup.open(videoUrl, index);
            });
        });
    }
});